import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">
        AJT.NSQB by
        <a href="#" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">Team VISION</a>
    </div>`
})
export class AppFooter {}
